export default "__VITE_ASSET__6e3l0PAl__"